<template>
  <sensor-virtual-autocomplete
    id="sensoresVirtuais"
    v-model="sensorVirtualId"
    name="sensoresVirtuais"
    :local-id="localId"
    :required="true"
  />
</template>

<script>
import http from '@/utils/http'

import SensorVirtualAutocomplete from '../../autocomplete/SensorVirtualAutocomplete.vue'

export default {
  name: 'TermoSensorVirtual',
  components: { SensorVirtualAutocomplete },
  props: {
    localId: {
      type: String,
      required: true,
    },
    initialSensorVirtualId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    sensoresVirtuais: [],
    sensorVirtualId: null,
  }),
  watch: {
    sensorVirtualId() {
      this.change()
    },
  },
  async beforeMount() {
    this.sensoresVirtuais = await http
      .get(`local/${this.localId}/sensor/virtual`)
      .then((e) => e.sensoresVirtual)

    if (this.initialSensorVirtualId) {
      this.sensorVirtualId = this.initialSensorVirtualId
    }
  },
  methods: {
    change() {
      let sensorVirtualSelected = null
      if (this.sensorVirtualId != null) {
        sensorVirtualSelected = this.sensoresVirtuais.find(
          ({ id }) => id === this.sensorVirtualId
        )
      }

      this.$emit('change', {
        sensorId: sensorVirtualSelected?.sensorId ?? null,
        sensorVirtualId: this.sensorVirtualId,
      })
    },
  },
}
</script>

<style scoped></style>
